var t=(t,e)=>a=>(a.target.value=a.target.value.slice(0,t),e(a));export{t as limitInputLength};
//# sourceMappingURL=limitInputLength.js.map